/**
 * Controls Page - ComplyIQ
 *
 * Stub page for managing compliance controls across frameworks.
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Shield, Plus, Search, Filter, Download } from 'lucide-react'

export function ControlsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-display font-bold">Controls</h2>
          <p className="text-muted-foreground">
            Manage compliance controls across NIST, CMMC, FedRAMP, and other frameworks
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline">
            <Download className="h-4 w-4 mr-2" />
            Export
          </Button>
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            Add Control
          </Button>
        </div>
      </div>

      {/* Filters */}
      <div className="flex gap-4 flex-wrap">
        <select className="h-10 px-4 rounded-lg border border-border bg-background text-sm">
          <option value="">All Frameworks</option>
          <option value="nist">NIST 800-53</option>
          <option value="cmmc">CMMC Level 2</option>
          <option value="fedramp">FedRAMP High</option>
        </select>

        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search controls..."
            className="w-full h-10 pl-10 pr-4 rounded-lg border border-border bg-background text-sm"
          />
        </div>

        <Button variant="outline">
          <Filter className="h-4 w-4 mr-2" />
          Filters
        </Button>
      </div>

      {/* Controls Table */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Shield className="h-5 w-5" />
            Controls
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12 text-muted-foreground">
            <Shield className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p className="text-lg font-medium">No controls to display</p>
            <p className="mt-2">
              Controls will appear here after they are available from ComplyIQ.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
